export const apiPublicKeyTestPrefix = 'pk_test_';
export const testnetPrefix = 'testnet-';
export const testnetShortPrefix = 'tn-';
//# sourceMappingURL=testnet-prefix.js.map